<template>
	<v-chip disabled :outline="vc_outline || false" :color="$store.getters.getTheme ? 'grey darken-2' : 'primary'" :text-color="vc_outline && $store.getters.getTheme ? 'white' : vc_outline ? 'primary' : 'white'">
		<v-avatar v-if="hasIcon" :class="$store.getters.getTheme ? 'grey darken-4' : 'primary darken-2'"><v-icon small class="white--text">{{ vc_icon }}</v-icon></v-avatar>
		{{ vc_title }}
	</v-chip>
</template>

<script>
export default {
	name: 'venture-chip',
	props: ['vc_icon', 'vc_title', 'hasIcon', 'vc_outline'],
	data() {
		return {
			icon_enable: true
		}
	}
}
</script>
